<script>
import { mapActions, mapGetters } from "vuex";
import UserCard from "../layout/UserCard.vue";
import AddUpdateUser from "./AddUpdateUser";

export default {
	name: "usersTable",
	components: {
		AddUpdateUser,
		UserCard
	},
	data() {
		return {
			headers: [
				{
					text: "Username",
					value: "username"
				},
				{
					text: "",
					value: "data-table-expand"
				}
			],
			expanded: [],
			showAddUser: false,
			search: ""
		};
	},
	computed: {
		...mapGetters("users", ["users"])
	},
	methods: {
		...mapActions("users", ["fetchUsers"]),
	},
	mounted() {
		return this.fetchUsers();
	}
};
</script>

<template>
	<v-data-table
		:headers="headers"
		:items="users"
		:items-per-page="15"
		:expanded.sync="expanded"
		show-expand
		class="usersTable"
		:search="search"
		item-key="_key"
	>
		<template v-slot:top>
			<v-toolbar flat>
				<v-text-field
					v-model="search"
					label="Search users"
					placeholder="Search users"
					append-icon="mdi-magnify"
					single-line
					hide-details
				/>
				<v-spacer/>
				<add-update-user/>
			</v-toolbar>
		</template>
		<template v-slot:item.username="{ item }">
			<v-icon>mdi-account</v-icon>
			{{ item.username }}
			{{ item.firstName || item.lastName ? `(${item.firstName} ${item.lastName})` : "" }}
		</template>
		<template v-slot:expanded-item="{headers, item}">
			<td :colspan="headers.length">
				<user-card :user="item"/>
			</td>
		</template>
	</v-data-table>
</template>

<style scoped lang="scss">
.usersTable {
	.v-icon.mdi-plus {
		cursor: pointer;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/elements/UsersTable.vue